import styled from 'styled-components'

export const Container = styled.div`
  height: 100vh;
  padding: 12px;
  color: ${props => (props.isDark ? '#ffffff' : '#000000')};
  background-color: ${props => (props.isDark ? '#363535' : '#F5F7FA')};
`

export const ShelvesContainer = styled.div`
  width: fit-content;
  height: 100%;
  padding: 20px;
  padding-right: 40px;
  color: ${props => (props.isDark ? '#ffffff' : '#000000')};
  background-color: ${props => (props.isDark ? '#000000' : '#ffffff')};
`
